import { Input } from 'antd'
import CIMSFormItem from '../..'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { HelpMessage } from 'utils/constants'
import { InitialValue } from '../../types'

/**
 * wraps a {@link CIMSFormItem} for `name` fields
 */
const NameFormItem: React.FC<
  InitialValue<string> & {
    /**
     * is the `name` nullable?
     */
    nullable?: boolean
    /**
     * a custom {@link HelpMessage}
     */
    help: string
  }
> = ({ nullable = false, initialValue, help }) => (
  <CIMSFormItem
    name="name"
    label="Name"
    help={help}
    requiredMessage={nullable ? undefined : 'Please enter a name'}
    initialValue={initialValue}
  >
    <Input allowClear />
  </CIMSFormItem>
)

export default NameFormItem
